import { injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';

import type { ClientMessage } from 'domain/types/client-message';

@injectable()
export class MessagesRepo {
  appMessages: ClientMessage[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  init = () => {
    this.reset();
  };

  reset = () => {
    this.appMessages = [];
  };
}
